/* eslint-disable no-undef */
import React from "react";
import { connect } from "react-redux";
import Layout from "../../Components/Layout";
import InfoActionPage from "../../Components/InfoActionPage";
import SettingsLayout from "./SettingsLayout";
import { closePanel, openPanel } from "../../Redux/Panels/RightPanel/actions";
import { FormContent } from "../../Components/FormContent";


const structure = [
	{
		title: "Basic Info",
		description: "Enter patient's personal information and login details.",
		fields: [
			{
				name: "age",
				label: "Age",
				width: 12,
			},
			{
				name: "weight",
				label: "Weight (kG)",
				width: 12,
			},
			{
				name: "height",
				label: "Height (cm)",
				width: 12,
			},
			{
				name: "blood_group",
				label: "Blood Group",
				width: 12,
				type: "select",
				options: [
					{ value: "O+", label: "O+" },
					{ value: "O-", label: "O-" },
					{ value: "A+", label: "A+" },
					{ value: "B+", label: "B+" },
				]
			},
			{
				name: "blood_sugar",
				label: "What is your blood sugar level?",
				width: 12,
			},
			{
				name: "blood_pressure",
				label: "What is your blood pressure level?",
				width: 12,
			},
			{
				name: "pulse_rate",
				label: "What is your pulse rate?",
				width: 12,
			},
			{
				name: "respiratory_rate",
				label: "What is your respiratory rate?",
				width: 12,
			},
			{
				name: "cholesterol_level",
				label: "What is your cholesterol level?",
				width: 12,
			},			
		],
	},
	{
		title: "Public Profile",
		description: "Enter patient's personal information and login details.",
		sectionClass: "mt-5 pt-5 border-top top-border",
		fields: [
			{
				name: "main_issue",
				label: "Main issue that you need consultation for",
				icon: "user",
				width: 12,
				type: "textarea",
			},
			{
				name: "what_done",
				label: "What have you done so far about it",
				icon: "user",
				width: 12,
				type: "textarea",
			},
			{
				name: "investigation_done",
				label: "Investigation done so far",
				icon: "user",
				width: 12,
				type: "textarea",
			},
			{
				name: "investigation_duration",
				label: "How long has this going on?",
				icon: "user",
				width: 12,
			},
			{
				name: "past_medical_history",
				label: "Past medical history( list your past medical conditions)",
				icon: "user",
				width: 12,
				type: "textarea",
			},
			{
				name: "past_surgical_history",
				label:
					"Past surgical history ( have you had any surgery in the past please list)",
				icon: "user",
				width: 12,
				type: "textarea",
			},
			{
				name: "obstetrics_gynaecology_history",
				label: "Obstetrics and gynaecology history",
				icon: "user",
				width: 12,
				type: "textarea",
			},
			{
				name: "paediatric_history",
				label:
					"Paediatric history ( developmental, birth history, immunization hx)",
				icon: "user",
				width: 12,
				type: "textarea",
			},
			{
				name: "family_history",
				label:
					"Family history ( medical condition in family, sudden death, stroke, DM etc)",
				icon: "user",
				width: 12,
				type: "textarea",
			},
			{
				name: "socio_history",
				label: "Socio History ( smoke/ alcohol)",
				icon: "user",
				width: 12,
				type: "textarea",
			},
			{
				name: "list_of_medication",
				label: "List of medication",
				icon: "user",
				width: 12,
				type: "textarea",
			},
		],
	},
	{
		title: "Cardiovascular",
		sectionClass: "mt-5 pt-5 border-top top-border w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Chest Pain",
						key: "chest_pain",
					},
					{
						name: "Shortness of breath",
						key: "shortness_of_breath",
					},
					{
						name: "Swelling of the feet",
						key: "swelling_of_the_feet",
					},
					{
						name: "Racing Pulse",
						key: "racing_pulse",
					},
					{
						name: "Irregular heart beat",
						key: "irregular_heart_beat",
					},
					{
						name: "None",
						key: "none_cardiovascular",
					},
				],
			},
			{
				name: "is_blood_pressure_under_control",
				label: "Is your blood pressure under control?",
				width: 12,
				type: "select",
				options: ["Yes", "No", "Unsure"],
			},
		],
	},
	{
		title: "Endocrine",
		sectionClass: "mt-5 pt-5 border-top top-border w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Excess thirst",
						key: "excess_thirst",
					},
					{
						name: "Excessive urination",
						key: "excessive_urination",
					},
					{
						name: "Heat Intolerance",
						key: "heat_intolerance",
					},
					{
						name: "Cold Intolerance",
						key: "cold_intolerance",
					},
					{
						name: "Hair loss",
						key: "hair_loss",
					},
					{
						name: "Dry skin",
						key: "dry_skin",
					},
					{
						name: "None",
						key: "none_cardiovascular",
					},
				],
			},
			{
				name: "is_blood_sugar_under_control",
				label: "Is your blood sugar under control?",
				width: 12,
				type: "select",
				options: ["Yes", "No", "Unsure"],
			},
		],
	},
	{
		title: "Gastrointestinal",
		sectionClass: "mt-5 pt-5 border-top top-border w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Abdominal pain",
						key: "abdominal_pain",
					},
					{
						name: "Nausea",
						key: "nausea",
					},
					{
						name: "Diarrhea",
						key: "diarrhea",
					},
					{
						name: "Bloody stools",
						key: "bloody_stools",
					},
					{
						name: "Stomach Ulcers",
						key: "stomach_ulcers",
					},
					{
						name: "Constipation",
						key: "constipation",
					},
					{
						name: "Trouble Swallowing",
						key: "trouble_swallowing",
					},
					{
						name: "Jaundice/Yellow skin",
						key: "jaundice_yellow_skin",
					},
					{
						name: "None",
						key: "none_gastrointestinal",
					},
				],
			},
		],
	},
	{
		title: "Integumentary",
		sectionClass: "mt-5 pt-5 border-top top-border w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Rash",
						key: "rash",
					},
					{
						name: "Change in mole",
						key: "change_in_mole",
					},
					{
						name: "Skin sores",
						key: "skin_sores",
					},
					{
						name: "Skin cancer",
						key: "skin_cancer",
					},
					{
						name: "Severe itching",
						key: "sever_itching",
					},
					{
						name: "Loss of hair",
						key: "loss_of_hair",
					},
					{
						name: "None",
						key: "none_integumentary",
					},
				],
			},
		],
	},
	{
		title: "Constitutional",
		sectionClass: "mt-5 pt-5 border-top top-border w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Fever",
						key: "fever",
					},
					{
						name: "Weight loss",
						key: "weight_loss",
					},
					{
						name: "Fatigue",
						key: "fatigue",
					},
					{
						name: "Loss of Appetite",
						key: "loss_of_appetite",
					},
					{
						name: "Chills",
						key: "chills",
					},
					{
						name: "Night Sweats",
						key: "night_sweats",
					},
					{
						name: "Poor appetite",
						key: "poor_appetite",
					},
					{
						name: "None",
						key: "none_constitutional",
					},
				],
			},
		],
	},
	{
		title: "Genitourinary",
		sectionClass: "mt-5 pt-5 border-top top-border w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Genital sores or ulcers",
						key: "genital_sores_ulcers",
					},
					{
						name: "Kidney Failure/Problems",
						key: "kidney_failure_problems",
					},
					{
						name: "Kidney stones",
						key: "kidney_stones",
					},
					{
						name: "Painful/difficult urination (Prostatitis)",
						key: "paintful_urination",
					},
					{
						name: "Testicular pain",
						key: "testicular_pain",
					},
					{
						name: "Urinary discharge",
						key: "urinary_discharge",
					},
					{
						name: "None",
						key: "none_genitourinary",
					},
				],
			},
		],
	},
	{
		title: "Hematology/Oncology",
		sectionClass: "mt-5 pt-5 border-top top-border w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Easy bruising",
						key: "easy_bruising",
					},
					{
						name: "Prolonged bleeding",
						key: "prolonged_bleeding",
					},
					{
						name: "None",
						key: "none_hematology_oncology",
					},
				],
			},
		],
	},
	{
		title: "HENT",
		sectionClass: "mt-5 pt-5 border-top top-border w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Hearing loss",
						key: "hearing_loss",
					},
					{
						name: "Sore throat",
						key: "sore_throat",
					},
					{
						name: "Runny nose",
						key: "runny_nose",
					},
					{
						name: "Dry mouth",
						key: "dry_mouth",
					},
					{
						name: "Jaw Claudication (pain in jaw when chewing)",
						key: "jaw_claudication",
					},
					{
						name: "Ear ache",
						key: "ear_ache",
					},
					{
						name: "None",
						key: "none_hematology_oncology",
					},
				],
			},
		],
	},
	{
		title: "Neurologic",
		sectionClass: "mt-5 pt-5 border-top top-border w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Weakness",
						key: "headaches",
					},
					{
						name: "Scalp tenderness",
						key: "scalp_tenderness",
					},
					{
						name: "Dizziness",
						key: "dizziness",
					},
					{
						name: "Paralysis of extremities",
						key: "paralysis_of_extremities",
					},
					{
						name: "Tremor",
						key: "tremor",
					},
					{
						name: "Stroke",
						key: "stroke",
					},
					{
						name: "Numbness or tingling",
						key: "numbness_or_tingling",
					},
					{
						name: "Seizures or convulsions",
						key: "seizures_or_convulsions",
					},
					{
						name: "Fainting",
						key: "fainting",
					},
					{
						name: "None",
						key: "none_neurologic",
					},
				],
			},
		],
	},
	{
		title: "Respiratory",
		sectionClass: "mt-5 pt-5 border-top top-border w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Wheezing",
						key: "wheezing",
					},
					{
						name: "Cough",
						key: "cough",
					},
					{
						name: "Coughing up blood",
						key: "coughing_blood",
					},
					{
						name: "Severe or Frequent colds",
						key: "severe_frequent_colds",
					},
					{
						name: "Difficulty breathing",
						key: "difficulty_breathing",
					},
					{
						name: "None",
						key: "none_respiratory",
					},
				],
			},
		],
	},
];

export const MedicalProfileContent = (props) => {
	const { updateProfile, PROFILE } = props;
	return (
		<div className="form-body p-5" style={{ paddingTop: "0px !important" }}>
					<div className="form-fieldset">
						<div className="columns is-multiline">
							<FormContent
								{...props}
								structure={structure}
								updateProfile={updateProfile}
								PROFILE={PROFILE}
							/>
						</div>
					</div>
				</div>
	)
};

export const MedicalProfile = (props) => {
	let USER = props?.user?.user || {}
	let PROFILE = props?.patient_record || JSON.parse(props?.user?.user?.medical_record || "{}");

	const [medicalProfileMessage, setMedicalProfileMessage] = React.useState(defaultMsg);
	const [view, setView] = React.useState(0);

	const [DATA, setDATA] = React.useState(PROFILE);

	const updateProfile = (d) => {
		setDATA({ ...DATA, ...d });
	};
	React.useEffect(() => {
		delete DATA.category;
		delete DATA.image;
		delete DATA.background_image;
		if (USER.role === 'PATIENT'){
			let message = `Your medical record has been updated!, to find a specialist, please click the button below.`;
			let action = {
				text: "Now meet a Specialist.",
				action: () => {
					window.open("https://evokeeclinic.com/search")
				}
			}
			medicalProfileMessage['action'] = action;
			medicalProfileMessage['message'] = message;
			setMedicalProfileMessage(medicalProfileMessage);
		}
		else{
			let	message = `Your medical record has been updated!, to go to your dashboard, please click the button below.`;
			let action = {
				text: "Go to Dashboard.",
				action: () => {
					window.open("https://evokeeclinic.com/dashboard")
				}
			}
			medicalProfileMessage['action'] = action;
			medicalProfileMessage['message'] = message;
			setMedicalProfileMessage(medicalProfileMessage);
		}
		
	}, []);

	return (
		<Layout sidePanel={true} title={"Medical Profile"}>
			{view === 1 ? (
				<InfoActionPage {...medicalProfileMessage} />
			): (						
			<SettingsLayout
				title={USER?.name+"\'s Medical Profile"}
				data={DATA}
				comms={{}}
				successCallback={()=>setView(1)}
				type='medicalprofile'
				btnText={"Update"}
				endPoint={`users/medical_history/`}
			>
				<MedicalProfileContent 
					{...props}
					updateProfile={updateProfile}
					PROFILE={PROFILE}
				/>
			</SettingsLayout>
			)}
		</Layout>
	);
};

export const defaultMsg = {
	title: "Your medical record has been updated",
	// message: `Your medical record has been updated!, to find a specialist, please click the button below.`,
	image: require("../../assets/images/undraw_order_confirmed_re_g0if.svg").default,
}

const mapStateToProps = ({ user }) => {
	return { user };
};

const mapDispatchToProps = (dispatch) => {
	return {
		closePanel: (e) => dispatch(closePanel(e)),
		openPanel: (e) => dispatch(openPanel(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(MedicalProfile);
